import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import RTPageLayout from '../common/RTPageLayout';
import Tile from '../common/Tile';
import RequireMenuAccess from '../common/RequireMenuAccess';
import '../common/rtCommon.css';

const tiles = [
  {
    title: 'Allocation Report',
    permissionKey: 'reports.allocations',
    icon: '📊',
    description: 'View allocation trends, durations, and discount analytics.',
    url: 'allocations',
  },
  {
    title: 'Payment Analytics',
    permissionKey: 'reports.payment_analytics',
    icon: '💰',
    description: 'View payment timing, methods, and comprehensive analytics.',
    url: 'payment-analytics',
  },
  {
    title: 'Rent Collection Report',
    permissionKey: 'reports.rent_collection',
    icon: '🏠',
    description:
      'Track rent invoices by month, view paid/unpaid status and collection summary.',
    url: 'rent-collection',
  },
  {
    title: 'Complaints Report',
    permissionKey: 'reports.complaints',
    icon: '📋',
    description:
      'View complaints by type, staff resolutions, and building analytics.',
    url: 'complaints',
  },
  {
    title: 'Expense Report',
    permissionKey: 'reports.expenses',
    icon: '📒',
    description:
      'Monthly and yearly expense analytics by category, staff, and payment method.',
    url: 'expenses',
  },
  {
    title: 'WhatsApp Logs',
    permissionKey: 'reports.whatsapp_logs',
    icon: '📱',
    description: 'View WhatsApp message logs and delivery status.',
    url: 'whatsapp-logs',
  },
  {
    title: 'Background Jobs',
    permissionKey: 'reports.jobs',
    icon: '⚙️',
    description: 'View background job status, history, and detailed results.',
    url: 'jobs',
  },
];

const ReportManagement = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <RequireMenuAccess>
      <RTPageLayout
        title="Reports Management"
        mainSection
        activePath={location.pathname}
      >
        <div className="rt-tiles-grid">
          {tiles.map((tile, idx) => (
            <Tile
              key={idx}
              title={tile.title}
              icon={tile.icon}
              description={tile.description}
              permissionKey={tile.permissionKey}
              onClick={() => tile.url && navigate(tile.url)}
              tabIndex={0}
              role="button"
              onKeyPress={(e) => {
                if (e.key === 'Enter' && tile.url) navigate(tile.url);
              }}
            />
          ))}
        </div>
      </RTPageLayout>
    </RequireMenuAccess>
  );
};

export default ReportManagement;
